import React, { useState } from 'react'

import { Box, Button, Divider, Drawer, IconButton, Typography } from '@mui/material'
import logo from 'assets/images/sectorLogos/logo-horizontal.svg'

import { MenuIcon, PersonIcon } from 'Sui_Icons'
import Close from '@mui/icons-material/Close'
import { Link } from 'react-router-dom'
import { Sidebar, SidebarUser } from 'pages/Dashboard/components'
import { UserProfile } from 'pages/Dashboard/components/Header/compoents'

export const SideMenu = ({ hideLogo, justifyContent }) => {

    const [menuVisiblity, setMenuVisibility] = useState(false)

    const infoUser = { role: 'user' }

    return (
        <>
            <Box sx={{ p: { lg: 2 }, m: { lg: 0 }, display: 'flex', mt: { xs: 0, lg: 0 }, width: '100%', position: 'fixed', top: 0, left: 0, p: 1, background: '#fff', zIndex: 1000, boxShadow: '0 0 10px #e2e2e2' }}  >
                <IconButton onClick={() => setMenuVisibility(true)} sx={{ display: { lg: 'none' }, mr: 1 }}><MenuIcon size={'26px'} /></IconButton>
                {!hideLogo && 
                    <Box component={Link} to='/' sx={{ display:'flex', justifyContent:'center', alignItems:'center', maxWidth: { xs: '95px', lg: 'unset' }, mt: { xs: 1, lg: 0 } }}>
                        <img style={{ width: '100%' }} src={logo} />
                    </Box>}
                {!!justifyContent && <IconButton sx={{ mr: 1, opacity: 0, zIndex: -1 }}><MenuIcon size={'26px'} /></IconButton>}
            </Box>

            <Drawer
                anchor={'left'}
                open={menuVisiblity}
                onClose={() => setMenuVisibility(false)}
                sx={{
                    display: { xs: 'flex', lg: 'none' },
                    zIndex: 2001,
                    '& .MuiPaper-root': {
                        alignItems: 'center',
                        boxSizing: 'border-box',
                        background: '#fff',
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                        display: { xs: 'flex', lg: 'none' },
                        flexDirection: 'column',
                        height: '100%',
                        overflowX: 'hidden',
                        margin: 0,
                        px: 3,
                        py: 1
                    }
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', background: 'white', width: '100%', height: '100%', alignItems: 'center' }}>
                    <Box sx={{ display: 'flex', width: '100%' }}>
                        <IconButton size='large' sx={{ float: 'left' }} onClick={() => setMenuVisibility(false)} ><Close /> </IconButton>
                    </Box>


                    {/* IsLogged In Status */}


                    {true ?

                        <>
                            <UserProfile />
                            <Box sx={{ display: 'flex', width: "100%", mt: 4 }}>

                                <Link to={'/topcourses'}><Typography fontSize={14} color={'#8EA7C6'}>دوره های آموزشی</Typography></Link>
                            </Box>

                            <Divider flexItem sx={{ mb: 0, mt: 3 }} />

                            {(infoUser?.role == 'admin' || infoUser?.role == 'creator') ? <Sidebar useInMobile={true} /> : <SidebarUser useInMobile={true} />}

                        </>

                        : <>
                            <Box sx={{ mt: 0, width: '100%', display: 'flex', justifyContent: 'center' }}>
                                <img style={{ width: '120px' }} src={logo} />
                            </Box>

                            <Divider flexItem />
                            <Box sx={{ mb: 1 }} >
                                <Button variant='contained' color="primary" sx={{ fontSize: '14px' }} startIcon={<PersonIcon />}>حساب کاربری</Button>
                            </Box>
                            <Box sx={{ display: 'flex', width: '70%', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <Button component={Link} to="/topcourses" color='action' variant='text' >دوره های آموزشی</Button>
                                <Button component={Link} to="/topquizes" color='action' variant='text' >آزمون ها</Button>
                                <Button component={Link} to="/about_us" color='action' variant='text' >سکتور چیست؟</Button>
                                <Button component={Link} to="/provision" color='action' variant='text'>قوانین و مقررات </Button>
                                <Button component={Link} to="/road_map" color='action' variant='text'>نقشــــــه راه</Button>
                            </Box>
                        </>}


                </Box>

            </Drawer>

            <Box sx={{ height: '30px', display: { lg: 'none' } }}>  </Box>

        </>
    )
}
